import { useState, useEffect } from 'react';
import API from "../providers/api";


const useSearch = (query) => {
  const [resultados, setResultados] = useState([]);
  const [isBusy, setIsBusy] = useState(true);

  useEffect(() => {
    const fetchResultados = async () => {
      if (typeof query !== 'string') {
        setIsBusy(false);
        setResultados([])
        return
      }
      setIsBusy(true);
      const palabras = query?.split(' ')


      const etiquetasList = []
      const tituloList = []

      palabras.forEach(palabra => {
        if (palabra.startsWith('#')) etiquetasList.push(palabra.replace('#', ''))
        else tituloList.push(palabra)
      })
      const etiquetas = etiquetasList.join(',')
      const titulo = tituloList.join(' ')

      const params = {}
      if (etiquetas) params.etiquetas = etiquetas
      if (titulo) params.titulo = titulo

      const res = await API.get("articulos", {params});
      if (res?.status !== 200) {
        setIsBusy(false);
        setResultados([])
        return
      }

      setResultados(res.data || [])
      setIsBusy(false);
    };

    if (query) {
      fetchResultados(query)
    } else {
      setIsBusy(false)
      fetchResultados([])
    }
  }, [query]);

  return { resultados, isBusy };
}

export default useSearch